import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'

import { setTradeIn, resetTradeIn, setCarInformations, resetCarInformations } from '../actions'
import Vehicle from './Vehicle'

const mapStateToProps = state => ({
  wizards: state.wizards,
  tradeIn: state.tradeIn,
  configuration: state.configuration
})

const mapDispatchToProps = {
  setWizards,
  setTradeIn,
  resetTradeIn,
  setCarInformations,
  resetCarInformations
}

export default connect(mapStateToProps, mapDispatchToProps)(Vehicle)
